export default "__VITE_ASSET__BkXePiHv__"